import { render, staticRenderFns } from "./RemoveAgateProjectButton.vue?vue&type=template&id=0e1b2b8c&"
import script from "./RemoveAgateProjectButton.vue?vue&type=script&lang=js&"
export * from "./RemoveAgateProjectButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports